/* ============================================================================
   EVA KARPATI — SHARED BEHAVIOUR
   ek-custom.js  ·  scroll reveals · gentle parallax · hero video safety
   ----------------------------------------------------------------------------
   • No framework, no jQuery. Load ONCE, deferred (see setup notes).
   • Idempotent — safe even if accidentally included twice.
   • Respects prefers-reduced-motion.
   ============================================================================ */
(function () {
  if (window.__ekInit) return;
  window.__ekInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ---- Reveal on scroll ------------------------------------------------ */
    var reveals = document.querySelectorAll('.ek-reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }

    /* ---- Gentle parallax  [data-ek-parallax]  (optional data-ek-speed) --- */
    var px = Array.prototype.slice.call(document.querySelectorAll('[data-ek-parallax]'));
    if (!reduce && px.length) {
      var ticking = false;
      var run = function () {
        var vh = window.innerHeight;
        px.forEach(function (el) {
          var host = el.closest('.ek-section') || el;
          var r = host.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var speed = parseFloat(el.getAttribute('data-ek-speed')) || 0.12;
          var offset = (r.top - vh / 2) * -speed;
          el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
        });
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(run); }
      }, { passive: true });
      run();
    }

    /* ---- Hero background video safety ------------------------------------ */
    document.querySelectorAll('.ek-hero__media[autoplay]').forEach(function (v) {
      if (typeof v.play !== 'function') return;
      if (reduce) { try { v.pause(); } catch (e) {} return; }
      var p = v.play();
      if (p && p.catch) p.catch(function () {/* autoplay blocked — poster shows */});
    });

  });
})();